"use client"

import '@/components/i18n/i18n';
import { useTranslation as useTranslationReactI18next } from "react-i18next";

export const useTranslation = useTranslationReactI18next;